import { create } from 'zustand';
import { AuthResponse, User } from '../types/auth';

export interface AuthState {
  user: User | null;
  token: string | null;
  login: (data: AuthResponse) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: null,
  login: (data: AuthResponse) =>
    set({ user: data.user || null, token: data.token }),
  logout: () => set({ user: null, token: null }),
}));
